import React, { useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import Auth from '@aws-amplify/auth'
import { useAuthConfig, useSession } from './AuthProvider'

const SignInCompletion = props => {
  const { afterAuthLocationCookieName } = useAuthConfig()
  const { updateSessionContext } = useSession()
  const destination = window.localStorage.getItem(afterAuthLocationCookieName) || '/'

  const [amplifyHasUpdatedState, setAmplifyHasUpdatedState] = useState(false)

  const checkAmplifyState = async () => {
    try {
      await Auth.currentAuthenticatedUser()
      await updateSessionContext(true)
      setAmplifyHasUpdatedState(true)
    } catch (inner) {
      await updateSessionContext(true)
      const error = new Error('Error while finishing sign in process.')
      error.inner = inner
      console.error(error)
    }
  }

  useEffect(() => {
    checkAmplifyState()
  }, [])

  return (
    <div>
      {props.children}
      {destination && amplifyHasUpdatedState && (
        <Navigate to={destination} replace />
      )}
    </div>
  )
}

export default SignInCompletion
